/**
 * size guide弹窗
 */
(function () {

  // 创建size guide弹窗html
  var sizeGuideContent = `
    <div class="ls-main-popupbox-overlay" style="z-index: 530;"></div>
    <div class="ls-main-popupbox-con" style="min-height: 90%;z-index: 540;">
      <!-- 标题区域 -->
      <div class="main-popupbox-con-title">${LS.$t('public.size_guide.pop_title')}
        <div class="title-close">
          <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/looksky_popup_close_phone2.png?v=1661931061" />
        </div>
      </div>
      <!-- SIZE GUIDE内容区域 -->
      <div class="main-popupbox-con-model">
        <div class="con-model-size-guide">
          <img class="loading-img" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/bodysize_loading.png?v=1647916707" />
        </div>
      </div>
    </div>
  `;

  // 详情页size guide弹窗数据内容模块
  var sizeGuideContentData = `
    <div class="model-size-guide-measurements-box" value="<%= data.productId %>">
      <div class="model-size-guide-measurements">
        <ul class="h-measurements-tabbox">
          <% for ( var [sizeHeaderIndex, sizeHeaderItem] of data.sizeHeaderList.entries() ) { %>
            <li <% if ( sizeHeaderIndex == 0 ) { %>class="active"<% } %> type="<%= sizeHeaderItem.type %>"><%= sizeHeaderItem.label %></li>
          <% } %>
        </ul>
      </div>
      <div class="title-right model-size-guide-chooise">
        <ul class="size-right-tab">
          <li class="active" type="in">inch</li>
          <div class="size-chooise-btnbox size-chooise-active"></div>
          <li type="cm">cm</li>
        </ul>
      </div>
      <ul class="h-measurements-tabbox-content">
        <% for ( var [sizeHeaderIndex, sizeHeaderItem] of data.sizeHeaderList.entries() ) { %>
          <li class="h-measurements-tabbox-li h-measurements-tabbox-<%= sizeHeaderItem.type %> <% if ( sizeHeaderIndex == 0 ) { %>tabbox-current<% } %>"></li>
        <% } %>
      </ul>
    </div>
  `;

  // 详情页size guide错误提示弹窗
  var sizeGuideContentError = `
    <!-- 错误提示区域 -->
    <div class="main-popup-con-error-prompt">
      <img class="error_img" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/looksky_error.png?v=1646038962" />
      <p class="p-tips"><%t('public.size_guide.error_text') %></p>
      <div class="h-prompt-refresh-btn" value="<%= data.productId %>"><%t('public.size_guide.error_btn') %></div>
    </div>
  `;

  // 定义sizeGuide的bodysize和productsize的公共内容区域
  var sizeGuidePublicContent = `
    <!-- Product size区域 -->
    <div class="model-size-guide-product-size">
      <% if ( data.tableListData && data.tableListData.length > 0 ) { %>
        <% for ( var tmpObj of data.tableListData ) { %>
          <div class="model-size-guide-product-size-box">
            <div class="model-size-guide-table">
              <% if ( tmpObj.headerList.length > 0 ) { %>
                <ul class="size-ul-table">
                  <!-- 第一个表格 -->
                  <li class="tablebox tablebox-current <% if (tmpObj.headerList.length > 3) { %>tablebox-length<% } %>">
                    <% if (tmpObj.headerList.length <= 3) { %>
                      <div class="tablebox-thead">
                        <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                          <p style="width: <%= 100/(tmpObj.headerList.length) %>%;"><%= item %></p>
                        <% } %>
                      </div>
                      <div class="tablebox-tbody">
                        <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                          <div class="tablebox-tbody-tr">
                            <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                              <!-- 判断表格类型 -->
                              <% var tableTypeIndex = data.tableType === "1" ? "1" : "2";%>
                              <% var tableStatusIndex = data.tableStatus === "1" ? "1" : "2";%>
                              <% if (tableStatusIndex === "1") { %>
                                <p style="width: <%= 100/(Object.keys(tmpObj.sizeTableRowList[0]).length-1) %>%;">
                                  <% if ( index2 < tableTypeIndex ) { %>
                                    <%= item[tmpObj.headerList[index2]] %>
                                  <% } else if ( index2 >= tableTypeIndex ) { %>
                                    <% if ( item[tmpObj.headerList[index2]] && item[tmpObj.headerList[index2]].indexOf("-") == -1 ) { %>
                                      <%= Math.round(item[tmpObj.headerList[index2]]*0.3937*100)/100 %>
                                    <% } else { %>
                                      <% if ( item[tmpObj.headerList[index2]] ) { %>
                                        <% for ( let [ index3, item3 ] of new Map( item[tmpObj.headerList[index2]].split("-").map( ( item, index ) => [ index, item ] ) ) ) { %>
                                          <%= Math.round(item3*0.3937*100)/100 %><% if ( index3+1 < item[tmpObj.headerList[index2]].split("-").length ) { %> -<% } %>
                                        <% } %>
                                      <% } %>
                                    <% } %>
                                  <% } %>
                                </p>
                              <% } else { %>
                                <p style="width: <%= 100/(Object.keys(tmpObj.sizeTableRowList[0]).length-1) %>%;">
                                  <%= item[tmpObj.headerList[index2]] %>
                                </p>
                              <% } %>
                            <% } %>
                          </div>
                        <% } %>
                      </div>
                    <% } else { %>
                      <!-- 左边区域 -->
                      <!-- 判断表格类型 -->
                      <% var tableTypeIndex = data.tableType === "1" ? "1" : "2";%>
                      <div class="tablebox-length-left">
                        <div class="tablebox-thead">
                          <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                            <% if ( index < tableTypeIndex ) { %>
                              <p><%= item %></p>
                            <% } %>
                          <% } %>
                        </div>
                        <div class="tablebox-tbody">
                          <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                            <div class="tablebox-tbody-tr">
                              <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                                <% if ( index2 < tableTypeIndex ) { %>
                                  <p><%= item[tmpObj.headerList[index2]] %></p>
                                <% } %>
                              <% } %>
                            </div>
                          <% } %>
                        </div>
                      </div>
                      <!-- 右边区域 -->
                      <div class="tablebox-length-right">
                        <div class="tablebox-length-right-box">
                          <div class="tablebox-thead">
                            <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                              <% if ( index >= tableTypeIndex ) { %>
                                <p><%= item %></p>
                              <% } %>
                            <% } %>
                          </div>
                          <div class="tablebox-tbody">
                            <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                              <div class="tablebox-tbody-tr">
                                <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                                  <% if ( index2 >= tableTypeIndex ) { %>
                                    <% var tableStatusIndex = data.tableStatus === "1" ? "1" : "2";%>
                                    <% if (tableStatusIndex === "1") { %>
                                      <p>
                                        <% if ( item[tmpObj.headerList[index2]] && item[tmpObj.headerList[index2]].indexOf("-") == -1 ) { %>
                                          <%= Math.round(item[tmpObj.headerList[index2]]*0.3937*100)/100 %>
                                        <% } else { %>
                                          <% if ( item[tmpObj.headerList[index2]] ) { %>
                                            <% for ( let [ index3, item3 ] of new Map( item[tmpObj.headerList[index2]].split("-").map( ( item, index ) => [ index, item ] ) ) ) { %>
                                              <%= Math.round(item3*0.3937*100)/100 %><% if ( index3+1 < item[tmpObj.headerList[index2]].split("-").length ) { %> -<% } %>
                                            <% } %>
                                          <% } %>
                                        <% } %>
                                      </p>
                                    <% } else { %>
                                      <p><%= item[tmpObj.headerList[index2]] %></p>
                                    <% } %>
                                  <% } %>
                                <% } %>
                              </div>
                            <% } %>
                          </div>
                        </div>
                      </div>
                    <% } %>
                  </li>
                  <!-- 第二个表格 -->
                  <li class="tablebox <% if (tmpObj.headerList.length > 3) { %>tablebox-length<% } %>">
                    <% if (tmpObj.headerList.length <= 3) { %>
                      <div class="tablebox-thead">
                        <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                          <p style="width: <%= 100/(tmpObj.headerList.length) %>%;"><%= item %></p>
                        <% } %>
                      </div>
                      <div class="tablebox-tbody">
                        <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                          <div class="tablebox-tbody-tr">
                            <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                              <p style="width: <%= 100/(Object.keys(tmpObj.sizeTableRowList[0]).length-1) %>%;"><%= item[tmpObj.headerList[index2]] %></p>
                            <% } %>
                          </div>
                        <% } %>
                      </div>
                    <% } else { %>
                      <!-- 左边区域 -->
                      <!-- 判断表格类型 -->
                      <% var tableTypeIndex = data.tableType === "1" ? "1" : "2";%>
                      <div class="tablebox-length-left">
                        <div class="tablebox-thead">
                          <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                            <% if ( index < tableTypeIndex ) { %>
                              <p><%= item %></p>
                            <% } %>
                          <% } %>
                        </div>
                        <div class="tablebox-tbody">
                          <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                            <div class="tablebox-tbody-tr">
                              <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                                <% if ( index2 < tableTypeIndex ) { %>
                                  <p><%= item[tmpObj.headerList[index2]] %></p>
                                <% } %>
                              <% } %>
                            </div>
                          <% } %>
                        </div>
                      </div>
                      <!-- 右边区域 -->
                      <div class="tablebox-length-right">
                        <div class="tablebox-length-right-box">
                          <div class="tablebox-thead">
                            <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                              <% if ( index >= tableTypeIndex ) { %>
                                <p><%= item %></p>
                              <% } %>
                            <% } %>
                          </div>
                          <div class="tablebox-tbody">
                            <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                              <div class="tablebox-tbody-tr">
                                <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                                  <% if ( index2 >= tableTypeIndex ) { %>
                                    <p><%= item[tmpObj.headerList[index2]] %></p>
                                  <% } %>
                                <% } %>
                              </div>
                            <% } %>
                          </div>
                        </div>
                      </div>
                    <% } %>
                  </li>
                </ul>
              <% } %>
            </div>
          </div>
        <% } %>
      <% } %>
    </div>
    <!-- 商品品类介绍区域 -->
    <% for ( var item of data.productCategory ) { %>
      <% if (item.type == data.measureTemplateType) { %>
        <div class="model-size-guide-title">
          <% if (data.measureTemplateType === 100) { %>
            <p class="p1"><%t('public.size_guide.bodysize_title') %></p>
          <% } else { %>
            <p class="p1"><%t('public.size_guide.productsize_title') %></p>
          <% } %>
        </div>
        <div class="model-size-guide-clothes-type">
          <div class="clothes-type-imgbox">
            <% for ( var item2 of item.imgList ) { %>
              <img src="<%= item2 %>" />
            <% } %>
          </div>
          <div class="clothes-type-listbox">
            <% for ( let [ index2, item2 ] of new Map( item.categoryList.map( ( item2, index2 ) => [ index2, item2 ] ) ) ) { %>
              <div class="clothes-type-listbox-li">
                <p class="p1"><span class="index"><%= index2+1 %></span><%= item2.label %></p>
                <p class="p2"><%= item2.value %></p>
              </div>
            <% } %>
          </div>
        </div>
      <% } %>
    <% } %>
    <!-- 底部提示区域 -->
    <div class="model-size-guide-email-tip">
      <p class="p1"><%t('public.size_guide.footer_text') %></p>
    </div>
  `;

	var sizeGuideFn = {

		/**
		 * 事件集合
		 */
		bindEvent: function () {

      // 点击刷新sizeguide弹窗重新获取数据
      $(document).on('click','.ls-main-popupbox-sizeguide .h-prompt-refresh-btn',function(){
        // 删除原来的弹窗
        $(".ls-main-popupbox-sizeguide").remove();
        // 通过接口创建sizeguide弹窗的方法
        // 创建初始弹窗
        var main_popup = document.createElement('div');
        main_popup.className = 'ls-main-popupbox ls-main-popupbox-sizeguide';
        main_popup.setAttribute('productId', $(this).attr("value"));
        document.body.appendChild(main_popup);
        var htmlBox = LS.tmpl(sizeGuideContent, {});
        // 添加到弹窗页面
        $(".ls-main-popupbox-sizeguide").html(htmlBox);
        sizeGuideFn.createSizeGuidePopupHandle($(this).attr("value"));
      });

      // SIZE GUIDE表格切换
      $(document).on('click','.ls-main-popupbox-sizeguide .size-right-tab',function(){
        var sizeType = $(this).find('.active').attr('type');
        // tab样式切换
        if ( sizeType == 'in' ) {
          // 样式修改
          $('.size-right-tab').find('.size-chooise-btnbox').removeClass('size-chooise-active');
          $('.size-right-tab').find("li:eq(0)").removeClass('active');
          $('.size-right-tab').find("li:eq(1)").addClass('active');
          // 表格切换
          $('.ls-main-popupbox-sizeguide .model-size-guide-product-size-box').find('.size-ul-table').children('li').removeClass('tablebox-current');
          $('.ls-main-popupbox-sizeguide .model-size-guide-product-size-box').find('.size-ul-table li:eq(1)').addClass('tablebox-current');
        } else {
          // 样式修改
          $('.size-right-tab').find('.size-chooise-btnbox').addClass('size-chooise-active');
          $('.size-right-tab').find("li:eq(0)").addClass('active');
          $('.size-right-tab').find("li:eq(1)").removeClass('active');
          // 表格切换
          $('.ls-main-popupbox-sizeguide .model-size-guide-product-size-box').find('.size-ul-table').children('li').removeClass('tablebox-current');
          $('.ls-main-popupbox-sizeguide .model-size-guide-product-size-box').find('.size-ul-table li:eq(0)').addClass('tablebox-current');
        }
      });

      // Measurements切换
      $(document).on('click','.h-measurements-tabbox li',function(){
        let measurementsTabIndex = $(this).index();
        // tab样式切换
        $(this).parents('.h-measurements-tabbox').children('li').removeClass('active');
        $(this).addClass('active');
        // table内容切换
        $(this).parents('.model-size-guide-measurements-box').find('.h-measurements-tabbox-content').children('li').removeClass('tabbox-current');
        $(this).parents('.model-size-guide-measurements-box').find(".h-measurements-tabbox-content .h-measurements-tabbox-li:eq(" + measurementsTabIndex +")").addClass('tabbox-current');
        // 点击Country/Region隐藏单位切换
        if (measurementsTabIndex == 2) {
          $('.model-size-guide-measurements-box .size-right-tab').attr('style', 'display: none;')
        } else {
          $('.model-size-guide-measurements-box .size-right-tab').attr('style', 'display: flex;')
        }
        // 上报
        if ( measurementsTabIndex == 0 ) {
          sizeGuideFn.reportSizeGuideInfo(LS.ui.productReportMap['clickSizeGuidePopProductSize'], LS.ui.reportType['click']);
        } else if ( measurementsTabIndex == 1 ) {
          sizeGuideFn.reportSizeGuideInfo(LS.ui.productReportMap['clickSizeGuidePopBodySize'], LS.ui.reportType['click']);
        } else if ( measurementsTabIndex == 2 ) {
          sizeGuideFn.reportSizeGuideInfo(LS.ui.productReportMap['clickSizeGuidePopCountry'], LS.ui.reportType['click']);
        }
      });

    },
    
    /**
     * sizeguide上报参数方法
     */
    reportSizeGuideInfo: function(ext1, reportType) {
      // 上报参数
      var params = {};
      var dataJson = {};
      dataJson.id = $('.ls-main-popupbox-sizeguide').attr('productid');
      dataJson.title = $('.product-title-wrapper').text() || '';
      params.ext2 = JSON.stringify(dataJson || []);
      // 上报
      LS.stat({
        eid: reportType,
        ext1,
        ...params
      });
    },

    /**
     * 
     * 通过接口创建sizeguide弹窗的方法
     */
    createSizeGuidePopupHandle: function (getProductId) {
      // 调用接口
      LS.ajax({
        url: LS.ui.routes.getProductSizeGuideInfo,
        type: "GET",
        data: {
          productId: getProductId,
        },
        success: function (response) {
          if (!response.hasError && response.code == '0') {
            // 判断有无size维度
            if (!response.data.sizeTables || response.data.sizeTables.length == 0) {
              // toast方法
              LS.ui.toastShowHandle(LS.$t('public.add_pop.lack_size_guide', '', 1));
            } else {
              // 创建弹窗
              sizeGuideFn.createSizeGuidePopup(response.data, '1', getProductId);
            }
            // 上报
            sizeGuideFn.reportSizeGuideInfo(LS.ui.productReportMap['showSizeGuidePopProductSize'], LS.ui.reportType['moduleShow']);
          } else {
            // 创建弹窗
            var customData = {
              'propertyGroupName': 'SIZE GUIDE',
              'productId': getProductId
            }
            sizeGuideFn.createSizeGuidePopup(customData, '2', getProductId);
          }
        },
        error: function (error) {
           LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },

    /**
     * 
     * 创建SizeGuide弹窗方法
     */
    createSizeGuidePopup: function (productSizeGuideData, setType, getProductId) {
      // 把自定义的商品品类介绍数据加入接口数据里
      productSizeGuideData.productCategory = productSizeGuideData.productMeasureList;
      var hiddenSizeTable = productSizeGuideData.hiddenSizeTable || false;
      var popupProductId = $('.ls-main-popupbox-sizeguide').attr('productid');
      var sizeHeaderList = [{
        label: 'Body Size',
        type: 'body'
      }, {
        label: 'Country/Region',
        type: 'countryregion'
      }];
      if (popupProductId && !hiddenSizeTable) {
        sizeHeaderList.unshift({
          label: 'Product Size',
          type: 'product'
        });
      }
      productSizeGuideData.sizeHeaderList = sizeHeaderList;
      // 生成
      if ( setType == '1' ) {
        var htmlStr = LS.tmpl(sizeGuideContentData, productSizeGuideData);
      } else {
        var htmlStr = LS.tmpl(sizeGuideContentError, productSizeGuideData);
      }

      // 添加到弹窗页面
      $(".ls-main-popupbox-sizeguide .con-model-size-guide").html(htmlStr);

      // 生成sizeguide的公用内容模块

      // bodysize数据
      var bodySizeDataInfo = JSON.parse(JSON.stringify(productSizeGuideData));
      bodySizeDataInfo.tableListData = productSizeGuideData.bodySizeList;
      bodySizeDataInfo.measureTemplateType = 100;
      bodySizeDataInfo.tableType = '2';
      bodySizeDataInfo.tableStatus = '1';
      var htmlBodySizeStr = LS.tmpl(sizeGuidePublicContent, bodySizeDataInfo);

      // productsize数据
      var productSizeDataInfo = JSON.parse(JSON.stringify(productSizeGuideData));
      productSizeDataInfo.tableListData = productSizeGuideData.sizeTables;
      productSizeDataInfo.tableType = '2';
      productSizeDataInfo.tableStatus = '1';
      var htmlProductSizeStr = LS.tmpl(sizeGuidePublicContent, productSizeDataInfo);

      // 添加bodysize,productsize公共区域
      $(".h-measurements-tabbox-body").html(htmlBodySizeStr);
      $(".h-measurements-tabbox-product").html(htmlProductSizeStr);

      // country/reginon数据
      var countryRegionStrInfo = JSON.parse(JSON.stringify(productSizeGuideData));
      countryRegionStrInfo.tableListData = [
        {
          headerList: productSizeGuideData.deminsSize ? ['Alpha size', 'Denim size', 'US', 'UK', 'AU', 'CAN'] : ['Alpha size', 'US', 'UK', 'AU', 'CAN'],
          sizeTableRowList: [
            {
              'Alpha size': 'XXS',
              'Denim size': '23',
              'US': '0（000）',
              'UK': '',
              'AU': '',
              'CAN': '0',
            },
            {
              'Alpha size': 'XS',
              'Denim size': '24 – 25',
              'US': '00 – 0',
              'UK': '4 – 6',
              'AU': '4 – 6',
              'CAN': '00 – 0',
            },
            {
              'Alpha size': 'S',
              'Denim size': '26 – 27',
              'US': '2 – 4',
              'UK': '8 – 10',
              'AU': '8 – 10',
              'CAN': '2 – 4',
            },
            {
              'Alpha size': 'M',
              'Denim size': '28 – 29',
              'US': '6 – 8',
              'UK': '10 – 12',
              'AU': '10 – 12',
              'CAN': '6 – 8',
            },
            {
              'Alpha size': 'L',
              'Denim size': '30 – 31',
              'US': '10 – 12',
              'UK': '14 – 16',
              'AU': '14 – 16',
              'CAN': '10 – 12',
            },
            {
              'Alpha size': 'XL',
              'Denim size': '32 – 33',
              'US': '14 – 16',
              'UK': '16 – 18',
              'AU': '16 – 18',
              'CAN': '14 – 16',
            },
            {
              'Alpha size': 'XXL',
              'Denim size': '34 – 35',
              'US': '18 – 20',
              'UK': '20',
              'AU': '20',
              'CAN': '18 – 20',
            },
          ]
        }
      ];
      countryRegionStrInfo.measureTemplateType = '';
      countryRegionStrInfo.tableType = productSizeGuideData.deminsSize ? '2' : '1';
      countryRegionStrInfo.tableStatus = '2';
      var htmlCountryRegionStr = LS.tmpl(sizeGuidePublicContent, countryRegionStrInfo);
      $(".h-measurements-tabbox-countryregion").html(htmlCountryRegionStr);
    },

    // 查看是否已经有sizeguide数据方法
    productSizeGuideDataInfoHandle: function (data, dom) {
      // 获取商品ID
      var getProductId = $(dom).attr('productId');
      // 判断是否已经存在弹窗，如果没有存在，创建弹窗内容，如果存在，则直接显示内容
      if ($('.ls-main-popupbox-sizeguide').html() && $('.ls-main-popupbox-sizeguide').attr('productId') == getProductId) {
        // 显示已有弹窗
        $('.ls-main-popupbox-sizeguide').show()
      } else {
        // 删除之前创建的弹窗
        $(".ls-main-popupbox-sizeguide").remove();
        // 创建初始弹窗
        var main_popup = document.createElement('div');
        main_popup.className = 'ls-main-popupbox ls-main-popupbox-sizeguide';
        main_popup.setAttribute('productId', getProductId);
        document.body.appendChild(main_popup);
        // 添加到弹窗页面
        $(".ls-main-popupbox-sizeguide").html(sizeGuideContent);
        // 判断是否有sizeguide数据
        if ( data ) {
          // 创建弹窗
          sizeGuideFn.createSizeGuidePopup(data, '1', getProductId);
          // 上报
          sizeGuideFn.reportSizeGuideInfo(LS.ui.productReportMap['showSizeGuidePopProductSize'], LS.ui.reportType['moduleShow']);
        } else {
          // 通过接口创建sizeguide弹窗的方法
          sizeGuideFn.createSizeGuidePopupHandle(getProductId);
        }
      }
      // 禁止弹窗底部滚动方法 
      LS.ui.popupNoScrollHandle();
      // 上报
      sizeGuideFn.reportSizeGuideInfo(LS.ui.productReportMap['clickSizeGuide'], LS.ui.reportType['click']);
      sizeGuideFn.reportSizeGuideInfo(LS.ui.productReportMap['showSizeGuidePop'], LS.ui.reportType['moduleShow']);
    }

	};

	function init() {
    sizeGuideFn.bindEvent();
    // app的sizeguide页插入
    if (location.href.indexOf("pages/size-guide") > 0) {
      // 获取商品ID
      var productId = LS.getParam("productid");
      // 通过接口创建sizeguide弹窗的方法
      sizeGuideFn.createSizeGuidePopupHandle(productId);
    }
	}

  init();

  LS.ui.sizeGuideFn = {
		productSizeGuideDataInfoHandle: sizeGuideFn.productSizeGuideDataInfoHandle
	};

})();